import Message from '../models/Message';
import store from '@/store';
import { EventBus } from '@/event-bus';
import {
  alreadyExistsJobByWhatsappIdentifier,
  alreadyExistsMessageWhatsapp,
} from '@/shared/utils/job-helpers';
import { newEvent } from '@/shared/utils/notification-title';
import { notify } from '@/shared/utils/browser-notify';

export default class NewWhatsAppMessageEvent {
  constructor(event) {
    let body = event.body;

    console.log(
      '%c [NewWhatsAppMessageEvent]',
      'color: #F44336;',
      JSON.stringify(event, null, 4),
    );
    const messageFounded = alreadyExistsMessageWhatsapp(
      body.message_id,
      body.protocol,
      store.state.jobs.jobList,
    );

    /* if(['image', 'sticker', 'audio', 'video', 'file'].includes(body.message_type) && body.protocol == store.state.jobs.activeJob){
            store.dispatch('whatsapp/getWhatsappNewMidia', { 
                content: body.message,
                params: {
                    phone: body.identifier,
                    org_unit_id: store.state.attendance.Attendance.org_unit_id
                } 
            })
        } */

    if (messageFounded) {
      console.log('Mensagem repetida!');
      return;
    }

    const isCampaignMessage = event?.strategyCampaign;

    let strategyCampaign = {};
    if (isCampaignMessage) {
      strategyCampaign.id = event?.strategyCampaign?.strategyCampaignId;
      strategyCampaign.name = event?.strategyCampaign?.strategyCampaignName;
      strategyCampaign.mailing_id = event?.strategyCampaign?.mailingId;
      strategyCampaign.mailing_name = event?.strategyCampaign?.mailingName;
      strategyCampaign.template_id = event?.strategyCampaign?.templateId;
    }

    try {
      const message = new Message({
        from: body.identifier,
        to: store.state.attendance.Attendance.agentId,
        message: JSON.parse(body.message.trim()),
        lastMessage: JSON.parse(body.message.trim()),
        type: isCampaignMessage ? 'send' : 'receipt',
        time: body.message_sent_at,
        status: null,
        protocol: body.protocol,
        agent_id: null,
        agent_name: null,
        avatar: null,
        system_message: null,
        mimetype: body.filemime,
        caption: body.message_caption,
        answeredMessage: body.customFields.isAnswered,
        message_id: body.message_id,
        message_media_type: body.message_media_type,
        bot: body.bot,
        apiMessageId: body.apiMessageId,
        forwarded: body?.forwarded || false,
        messageAnswered: body?.messageAnswered || {},
        strategyCampaign: isCampaignMessage ? strategyCampaign : {},
        event: body.event,
      });

      this._newMessage(body, message);
      return;
    } catch (err) {
      const message = new Message({
        from: body.identifier,
        to: store.state.attendance.Attendance.agentId,
        message: body.message_attachment_url
          ? body.message_attachment_url
          : body.message,
        type: isCampaignMessage ? 'send' : 'receipt',
        time: body.message_sent_at,
        apiMessageId: body.apiMessageId,
        forwarded: body?.forwarded || false,
        messageAnswered: body?.messageAnswered || {},
        protocol: body.protocol,
        status: null,
        system_message: null,
        strategyCampaign: isCampaignMessage ? strategyCampaign : {},
        event: body.event,
      });

      this._newMessage(body, message);
      return;
    }
  }

  hasFocus(protocol) {
    if (document.visibilityState === 'hidden') return true;
    const currentPath = window.location.pathname;
    if (currentPath.includes(protocol)) return true;
    return false;
  }

  _newMessage(body, message, tries = 0) {
    const jobFound = alreadyExistsJobByWhatsappIdentifier(
      message.protocol,
      store.state.jobs.jobList,
    );

    if (jobFound) {
      store.dispatch('jobs/receiveWhatsAppMessage', {
        protocol: message.protocol,
        message,
      });
      body.inbox = true;

      EventBus.$emit('new-message', body);
      EventBus.$emit('new-whatsapp-message-sound');
      newEvent();

      if (
        store.state.attendance.Attendance.agentPreferences &&
        store.state.attendance.Attendance.agentPreferences.notifyWhatsAppMessage
      ) {
        const notifyProtocol = body.protocol;
        const job = store.state.jobs.jobList.find(
          (job) => job.protocol == notifyProtocol,
        );
        let title = job.contact ? job.contact.fullname : body.identifier;
        if (!title) title = body.identifier;
        const notification = {
          title,
          body: JSON.parse(body.message.trim()),
          phoneNumber: '',
        };
        if (this.hasFocus(body.protocol)) {
          notify(notification, true, 'whatsapp');
          setTimeout(async () => {
            await store.dispatch('jobs/readAllMessages', body.protocol);
          }, 750);
        }
      }

      return;
    }

    const whatsAppPhone = body.from.split('@')[0];
    const routePhone = body.from.split('@')[1];

    const inboxJobFound = store.state.jobs.inboxJobs.find(
      (inboxJob) =>
        inboxJob.whatsAppPhone == whatsAppPhone &&
        inboxJob.routePhone == routePhone,
    );

    if (inboxJobFound != undefined) {
      store.dispatch('jobs/newWhatsAppMessageNotification', {
        whatsAppPhone,
        routePhone,
      });
    }

    store.dispatch('jobs/saveUnattendedMessage', {
      message,
      protocol: body.protocol,
    });
  }
}
